import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/LoginView.vue'),
    meta: { guest: true }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/RegisterView.vue'),
    meta: { guest: true }
  },
  {
    path: '/activate',
    name: 'Activate',
    component: () => import('@/views/ActivateView.vue'),
    meta: { guest: true }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/ForgotPasswordView.vue'),
    meta: { guest: true }
  },
  {
    path: '/reset-password',
    name: 'ResetPassword',
    component: () => import('@/views/ResetPasswordView.vue'),
    meta: { guest: true }
  },
  {
    path: '/',
    component: () => import('@/components/layout/AppLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Home',
        component: () => import('@/views/HomeView.vue')
      },
      {
        path: 'configurations/:configId/schedulings/new',
        name: 'SchedulingCreate',
        component: () => import('@/views/SchedulingFormView.vue'),
        props: true
      },
      {
        path: 'configurations/:configId/schedulings/:schedulingId',
        name: 'SchedulingEdit',
        component: () => import('@/views/SchedulingFormView.vue'),
        props: true
      },
      {
        path: 'schedulings',
        name: 'Schedulings',
        component: () => import('@/views/SchedulingsView.vue')
      },
      {
        path: 'profile',
        component: () => import('@/views/profile/ProfileLayout.vue'),
        children: [
          {
            path: '',
            redirect: { name: 'ProfileData' }
          },
          {
            path: 'data',
            name: 'ProfileData',
            component: () => import('@/views/profile/ProfileDataView.vue')
          },
          {
            path: 'plan',
            name: 'ProfilePlan',
            component: () => import('@/views/profile/ProfilePlanView.vue')
          },
          {
            path: 'payments',
            name: 'ProfilePayments',
            component: () => import('@/views/profile/ProfilePaymentsView.vue')
          }
        ]
      },
      {
        path: 'settings',
        name: 'Settings',
        component: () => import('@/views/SettingsView.vue')
      }
    ]
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/login'
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('mirra_token')

  if (to.meta.requiresAuth && !token) {
    next({ name: 'Login', query: { redirect: to.fullPath } })
  } else if (to.meta.guest && token) {
    next({ name: 'Home' })
  } else {
    next()
  }
})

export default router
